import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

const IconHeading = ({ icon, children }) => (
  <div className="modal-icon">
    <div className="modal-icon-outer">
      <div className="modal-icon-inner a-bg-25">
        <img src={icon} alt="" />
        {children}
      </div>
    </div>
  </div>
);

const Heading = ({ title, subtitle }) => (
  <div className="modal-headings">
    <h5 className="modal-heading">{title}</h5>
    <p className="sub-heading">{subtitle}</p>
  </div>
);

const Head = ({ title }) => (
  <div className="modal-head">
    <h5 className="modal-heading">{title}</h5>
  </div>
);

const Content = ({ children }) => (
  <div className={modalContent}>
    {children}
  </div>
);

const Footer = ({ children, style, className = "" }) => (
<div className={`btn-container btn-container--btns-on-right width-full modal-btn-container ${className}`} style={style}>
  {children}
</div>
);

const Text = ({ children }) => (
<p className="modal-text">
  {children}
</p>
);

const Modal = {
  IconHeading,
  Heading,
  Content,
  Footer,
  Head,
  Text
};

IconHeading.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.any
};

Heading.propTypes = {
  title: PropTypes.oneOfType([ PropTypes.string, PropTypes.node, PropTypes.object ]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

Head.propTypes = {
  title: PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]).isRequired,
};

Footer.propTypes = {
  children: PropTypes.any.isRequired
}

Text.propTypes = {
  children: PropTypes.any.isRequired
}

Content.propTypes = {
  children: PropTypes.any.isRequired
}

export default Modal;

const modalContent = css`
  padding: 0 40px;
`;


// WEBPACK FOOTER //
// ./src/components/reduxModal/Layout.jsx